// NatGen Google Floodlight snippet for clicking the quote start button
export function natgenFloodlightQuoteStartButton() {
    // eslint-disable-next-line no-undef
    gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'u1': '[orderID]',
        'send_to': 'DC-1886972/natg694/ngbey0+unique'
    });
}
